import { phone, cep, cpf } from "src/framework/commons/masks";
import { POSICAO_MODULO, PROPOSTA_OPTIONS } from "../constants";
import { ListagemItem, EstruturaListagemResponse, Bateria, ModuloPorRegiaoListagemResponse } from "../types";
import { ProjetoComponente, ProjetoOutput  } from "./types";
import { Conta, Estado, Regiao } from "src/types";
import { cnpj } from "src/framework/commons/masks";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { apiNoLoading } from "src/framework/providers/api";
import { Componente, ID_MODULO } from "src/components/componentes/types";
import { ProjetosHibridoProvider } from "src/providers/ProjetosHibridoProvider";
import { calcularEstruturas } from "../dimensionados_hibrido/utils/calcularEstruturas";
import { oldEstruturasHibrido$ } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType, SolucaoCalculadaHibrido, SolucaoSugeridaHibrido } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { calcularAcessorios } from "../dimensionados_hibrido/utils/calcularAcessorios";
import { calcularPotenciaEquipamentosHibrido } from "../utils/calcularPotenciaEquipamentosHibrido";
import { buscarEstruturasPorModulo } from "../dimensionados_hibrido/utils/buscarEstruturasPorModulo";
import { elSemEstrutura } from "../dimensionados_hibrido/containers/modalEditarEstruturas";
import { TENSAO_SAIDA_OPTIONS } from "../hibrido/FormClienteHibrido/containers/TensaoSaidaInput";
import { TAXA_DESCARGA_OPTIONS } from "../hibrido/FormClienteHibrido/containers/TaxaDescargaInput";
import { TIPO_LIGACAO_OPTIONS } from "../hibrido/FormClienteHibrido/containers/TipoLigacaoInput";
import { subMonths } from "date-fns";
import { HIBRIDO_SEM_BATERIA_OPTION } from "../hibrido/FormClienteHibrido/containers/TipoBateriaInput";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { DEFAULT_PROJETO_HIBRIDO } from "src/store/vendas/projetos/hibrido/hibrido.constants";
import { safeGeocodeByAddress } from "src/framework/commons/MapsUtil";

interface EstruturasOutput {
  ativos: EstruturaListagemResponse[];
  todos: EstruturaListagemResponse[];
  retrato: EstruturaListagemResponse[];
  paisagem: EstruturaListagemResponse[];
}

interface Props {
  estados: Estado[]
  regioes: any[];
  estadosServico: any[];
  clonarProjeto: boolean;
  cachedComponentes: Componente[];
  cachedCategoriasAcessoriosIds: number[]
}

const componenteProvider = new ComponenteProvider()
const projetosHibridoProvider = new ProjetosHibridoProvider();
const projetosProvider = new ProjetosProvider();

export type ProjetoCargaPrioritariaHibrido = {
  id: number;
  nome: string
  potencia: number;
  quantidade: number;
  horas_uso: number;
  fator_potencia: number;
  relacao_partida: number;
  consumo_diaria: number
}

export interface ProjetoOutputHibrido extends Omit<ProjetoOutput, "solucao_sugerida" | "componentes"> {
  cargas_prioritarias: Array<ProjetoCargaPrioritariaHibrido>
  solucao_sugerida: SolucaoSugeridaHibrido
  componentes: ProjetoComponente[]
}

export class ProjetoHelperHibrido {
  public moduloSelecionado: ProjetoOutputHibrido["componentes"][0] | null = null;
  public regioesProjeto: number[] = [];
  public solucaoCalculada: SolucaoCalculadaHibrido | null = null;
  public estruturasListagem: EstruturasOutput = {
    ativos: [],
    paisagem: [],
    retrato: [],
    todos: [],
  }
  public bateriasListagem: Bateria[] = [];
  public modulosListagem: ModuloPorRegiaoListagemResponse[] = [];
  public acessoriosCalculados: (ListagemItem & { quantidade_minima_finame: number })[] = [];
  public estruturasCalculadas: ListagemItem[] = [];
  public valorMinimoServico: { valor_minimo_servico: number } | null = null;
  
  constructor(private data: ProjetoOutputHibrido, private readonly props: Props){
    this.data = this.normalizar()
    this.definirModuloSelecionado();
    this.definirRegioes();
  }

  formatarSugestoes(): { acessorios: { id: number; quantidade: number; categoria_componentes_id: number; }[]; } {
    if (!this.data.solucao_sugerida) return DEFAULT_PROJETO_HIBRIDO.sugestoes;

    const componentesSugeridosProjeto = this.data.solucao_sugerida.componentes || []
    
    const acessorios = this.props.cachedComponentes.filter((item: any) => {
      return this.props.cachedCategoriasAcessoriosIds.includes(item.categoria_componentes_id)
    })

    const acessoriosSugerido = componentesSugeridosProjeto.filter(item => {
      return acessorios.map((item: any) => item.id).includes(item.id)
    })?.map(item => ({ id: item.id, quantidade: item.quantidade, categoria_componentes_id: item.categoria_componentes_id }))

    return {
      acessorios: acessoriosSugerido || DEFAULT_PROJETO_HIBRIDO.sugestoes.acessorios || [],
    }
  }
  
  definirModuloSelecionado = () => {
    const moduloSelecionado = this.data.componentes.find(item => item.componente.categoria_componentes_id === ID_MODULO) || null;
    if (!moduloSelecionado) {
      console.error("Modulo selecionado não encontrado")
    }

    this.moduloSelecionado = moduloSelecionado;
  }
  
  calcularValorServico = async () => {
    const valorMinimoServicoResult = await projetosProvider.calcularValorMinimoServico(this.data.solucao_sugerida.potencia_modulos, apiNoLoading);
    this.valorMinimoServico = valorMinimoServicoResult.data;
  }

  calcularEstruturas = async () => {
    const fileirasComEstrutura = this.data.solucao_sugerida.fileiras.filter(item => {
      return item.estrutura_id !== 0;
    })

    if (!fileirasComEstrutura.length) return;

    const result = await calcularEstruturas({
      fileiras: fileirasComEstrutura.map(item => ({
        fileiras: item.fileiras_iguais,
        posicao_modulo: POSICAO_MODULO.find(posItem => item.posicao === posItem.value) || null,
        quantidade_modulos: item.modulos_sequencia,
        tipo_estrutura: { value: item.estrutura_id, image: '', text: '' },
      })),
      inversor: '',
      moduloId: this.moduloSelecionado?.componente.id || 0,
      potencia: this.data.solucao_sugerida.potencia_desejada_kw,
      regioes: this.regioesProjeto,
    })
    oldEstruturasHibrido$.next(result);
    this.estruturasCalculadas = result.map(item => {
      const componenteProj = this.data.componentes.find(comp => comp.componente.id === item.componente_id);

      return {
        ...item,
        quantidade: componenteProj?.quantidade ?? item.quantidade ?? 0,
      }
    });
  }

  buscarBaterias = async () => {
    const result = await componenteProvider.buscarBateriasPorRegiao(
      this.regioesProjeto, 
      "on",
      true,
    )

    this.bateriasListagem = result.data || [];
  }

  calcularAcessorios = async () => {
    const result = await calcularAcessorios({
      moduloId: this.moduloSelecionado?.componente.id || 0,
      regioes: this.regioesProjeto,
      inversores: this.solucaoCalculada?.inversores || [],
      quantidade_modulos: this.moduloSelecionado?.quantidade || 0,
      projetoFiname: (this.data.componentes_finame || [])?.length > 0,
    })

    this.acessoriosCalculados = result.data.map(item => {
      const componenteProj = this.data.componentes.find(comp => comp.componente.id === item.componente_id);

      return {
        ...item,
        quantidade: componenteProj?.quantidade ?? item.quantidade ?? 0,
      }
    })
  }

  calcularSolucao = async () => {
    const cargasPrioritarias = this.data.cargas_prioritarias || [];

    const solucaoCalculada = await projetosHibridoProvider.calcularSolucao({
      regioes: this.regioesProjeto,
      carga_equipamentos: this.data.solucao_sugerida.total_carga_equipamentos_kw,
      modulo_id: this.moduloSelecionado?.componente.id || 0,
      potencia_desejada: this.data.solucao_sugerida.potencia_desejada_kw,
      potencia_equipamentos: cargasPrioritarias.length ? calcularPotenciaEquipamentosHibrido(cargasPrioritarias.map(carga => ({
        ...carga,
        consumo_diaria: carga.consumo_diaria,
      })))?.total_kva : 0,
      quantidade_modulos: this.moduloSelecionado?.quantidade || 0,
      taxa_descarga: this.data.solucao_sugerida.taxa_descarga || 0,
      tensao_saida: this.data.solucao_sugerida.tensao_saida || 0,
      tipo_bateria: this.data.solucao_sugerida.tipo_bateria || 0,
      tipo_conexao: this.data.solucao_sugerida.tipo_ligacao || 0,
    })

    if (solucaoCalculada.data) {
      // if (solucaoCalculada.data.modulo?.alterouQuantidade && !!this.moduloSelecionado) {
      //   this.moduloSelecionado.quantidade = solucaoCalculada.data.modulo.quantidade || this.moduloSelecionado.quantidade || 0
      // }

      this.solucaoCalculada = {
        baterias: solucaoCalculada.data.baterias.map(item => {
          const componenteProj = this.data.componentes.find(comp => comp.componente.id === item.id);
          return {
            ...item,
            quantidade: componenteProj?.quantidade || item?.quantidade || 0,
          }
        }),
        inversores: solucaoCalculada.data.inversores.map(item => {
          const componenteProj = this.data.componentes.find(comp => comp.componente.id === item.id);
          return {
            ...item,
            quantidade: componenteProj?.quantidade || item.quantidade || 0,
          }
        }),
      }
    }
  }
  
  definirRegioes() {
    this.regioesProjeto = this.data.solucao_sugerida.regiao_id || [];
  }
  
  buscarModulos = async () => {
    const result = await componenteProvider.buscarModulosPorRegiao(
      this.regioesProjeto.map(String), 
      Number(this.data.solucao_sugerida.potencia_desejada_kw),
      undefined,
      undefined,
      undefined,
      undefined,
      "on",
    )

    this.modulosListagem = result
  }
  
  buscarEstruturas = async () => {
    const result = await buscarEstruturasPorModulo({
      moduloId: this.moduloSelecionado?.componente.id || 0,
      potencia: this.data.solucao_sugerida.potencia_modulos ? DecimalUtil.toFixed(this.data.solucao_sugerida.potencia_modulos / 1000, 2) : 0,
      regioesId: this.data.solucao_sugerida.regiao_id || [],
    })

    this.estruturasListagem = result || [];
  }

  getLatLngFromAddress = async (): Promise<{ lat: number; lng: number }> => {
    const { logradouro, numero, bairro, cep }  = this.data.endereco;
    const { cidade, estado_id } = this.data
    const endereco = `${logradouro || ''}, ${numero || ''}, ${bairro || ''}, ${cidade?.nome || ''}, ${estado_id}, ${cep}`
    
    try {
      const res = await safeGeocodeByAddress(endereco)
      if (!res?.[0]) return { lat: 0, lng: 0 }
      return getLatLng(res[0])
    } catch (error) {
      return {
        lat: 0,
        lng: 0,
      }
    }
  }

  normalizar = (): ProjetoOutputHibrido => {
    const maskedPhone = phone({ target: { value: this.data.telefone_proposta || '' } })?.target?.value || ''
    const maskedCep = cep({ target: { value: this.data.endereco?.cep || '' } })?.target?.value || ''
    const maskedCpfCnpj = this.formatarCpfOuCnpj(this.data.cpf_cnpj_proposta)

    return {
      ...this.data,
      telefone_proposta: maskedPhone,
      cpf_cnpj_proposta: maskedCpfCnpj,
      endereco: {
        ...(this.data.endereco || {}),
        cep: maskedCep,
      },
    };
  }

  formatarCpfOuCnpj = (value: string) => {
    if (!value) return '';
    const onlyNumbers = value?.replace(/[^\d]/g, '')
    return onlyNumbers.length === 14 ? cnpj({ target: { value: onlyNumbers } })?.target?.value || '' : cpf({ target: { value: onlyNumbers } })?.target?.value || ''
  }

  buscarEstado = (): { id: string; nome: string } | undefined => {
    if (!this.data.estado_id) return undefined;
    const estado = this.props.estados?.find((item) => item.id === this.data.estado_id)
    return estado ? { id: estado.id, nome: estado.nome } : undefined
  }

  mostrarOpcaoServico = () => {
    if (!this.data?.id) return true;
    const reg = this.props.regioes || []
    const estadosServico = this.props.estadosServico || []
    const estadosPermitemServico: string[] = estadosServico.map((item: any) => item.regiao_id)
    const currentRegioes: string[] = reg.filter((item: Regiao) => {
      if (!item.estados || item.estados.length === 0) return false;
      const ids = item.estados.map((estado: any) => estado.estado_id)
      return ids.includes(this.data.estado_id)
    }).map((item: any) => item.id)
    return estadosPermitemServico.some(item => {
      if (currentRegioes.includes(item)) return true;
      return false;
    })
  }

  getRegioes = () => {
    if (!this.data.estado_id) return []
    return this.props.regioes?.filter((regiao: any) => {
      const estadosList = regiao.estados || []

      const estados = estadosList.map((item: any) => item.estado_id)
      return estados.includes(this.data.estado_id)
    }).map(item => item.id)
  }

  formatarCargasPrioritarias = (clonarProjeto: boolean): FormProjetoHibridoType["cargas_prioritarias"] => {
    return (this.data.cargas_prioritarias || []).map(item => ({
      id: clonarProjeto ? undefined : item.id,
      consumo_diaria: item.consumo_diaria,
      horas_uso: item.horas_uso,
      nome: item.nome,
      potencia: item.potencia,
      quantidade: item.quantidade,
      fator_potencia: item.fator_potencia,
      relacao_partida: item.relacao_partida,
    }))
  }

  get fileiras(): { fileiras: FormProjetoHibridoType["fileiras"]; fileiras_invalidas: number[] } {
    const fileirasInvalidas: number[] = [];
    
    const fileiras = this.data.solucao_sugerida.fileiras.map((fileira, index) => {
      let statusFileira: "sem_estrutura" | "nao_encontrado" | 'ok' = 'ok'
      const posicaoFileira = fileira.posicao || null;
      const estruturaListagem = posicaoFileira === 'retrato' ? this.estruturasListagem.retrato : this.estruturasListagem.paisagem;

      if (fileira.estrutura_id === 0) {
        statusFileira = "sem_estrutura"
      }

      const estruturaSelecionada = statusFileira === 'sem_estrutura' ? null : estruturaListagem.find(
        estrutura => estrutura.id === fileira.estrutura_id && 
        estrutura?.estruturas_grupo_id === fileira?.estruturas_grupo_id && 
        estrutura?.grupos?.length > 0
      );

      if (estruturaSelecionada === undefined) {
        statusFileira = "nao_encontrado"
        fileirasInvalidas.push(index)
      }

      const findGrupo = estruturaSelecionada?.grupos?.find(g => g.id === estruturaSelecionada.estruturas_grupo_id) || estruturaSelecionada?.grupos?.[0];
      let itemImageUrl = findGrupo?.url_imagem || estruturaSelecionada?.url_imagem || elSemEstrutura.url_imagem;

      let estruturaLocal: any = elSemEstrutura;

      if (statusFileira === 'ok' && estruturaSelecionada) {
        estruturaLocal = {
            image: itemImageUrl,
            text: estruturaSelecionada?.nome,
            value: estruturaSelecionada?.id,
            estruturas_grupo_id: estruturaSelecionada?.estruturas_grupo_id,
            grupos: estruturaSelecionada.grupos || [],
          };
      }

      if (statusFileira === 'nao_encontrado') {
        estruturaLocal = null
      }

      return {
        fileiras: fileira.fileiras_iguais,
        posicao_modulo: POSICAO_MODULO.find(posicao => posicao.value === fileira.posicao) || null,
        quantidade_modulos: fileira.modulos_sequencia,
        tipo_estrutura: estruturaLocal
      }
    })

    return {
      fileiras,
      fileiras_invalidas: fileirasInvalidas
    };
  }

  formatar = async (): Promise<(FormProjetoHibridoType & { fileiras_invalidas?: number[] })> => {
    await Promise.all([
      this.buscarEstruturas(),
      this.buscarBaterias(),
      this.buscarModulos(),
      this.calcularSolucao(),
      this.calcularValorServico(),
    ])

    await Promise.all([
      this.calcularAcessorios(),
      this.calcularEstruturas(),
    ])

    const latLngFromAddress = await this.getLatLngFromAddress()
    const tipoProposta = PROPOSTA_OPTIONS.find(item => item.value === (!!this.data.valor_servico ? 'gerador-com-instalacao' : 'gerador-sem-instalacao')) || null

    return {
      id: this.data.id,
      alterou_modulo: false,
      acessorios: [],
      tipo: "dimensionado",
      tipo_proposta: tipoProposta,
      titulo: this.data.titulo,
      todas_estruturas: [],
      total_carga_equipamentos_kw: this.data.solucao_sugerida.total_carga_equipamentos_kw,
      total_carga_equipamentos_w: this.data.solucao_sugerida.total_carga_equipamentos_w,
      valor_minimo_servico: 0,
      valor: this.data.valor || 0,
      valor_servico: this.data.valor_servico || 0,
      valor_servico_pis_cofins: this.data.valor_servico_pis_cofins || 0,
      codigo_servico: this.data.codigo_servico,
      estado: this.buscarEstado(),
      estado_original: this.buscarEstado(),
      estado_id: this.data.estado_id,
      revenda: (this.data.revenda as unknown) as Conta,
      justificativa_valor_servico: this.data.justificativa_valor_servico || null,
      revenda_id: this.data.revenda?.id,
      regioes: this.getRegioes(),
      latitude: latLngFromAddress.lat,
      longitude: latLngFromAddress.lng,
      baterias: [],
      cidade: this.data.cidade ? { estado_id: this.data.cidade.estado_id, cidade_codigo: this.data.cidade.cidade_codigo, id: this.data.cidade.id, nome: this.data.cidade.nome } : null,
      cidade_id: this.data.cidade?.id,
      cliente_proposta: this.data.cliente_proposta,
      clonar_projeto: this.props.clonarProjeto,
      codigo_venda: this.data.codigo_venda,
      distribuidor: this.data.distribuidor ? {
        cnpj_cpf: this.data.distribuidor.cnpj_cpf,
        fantasia: this.data.distribuidor.fantasia,
        id: this.data.distribuidor.id,
        nome: this.data.distribuidor.nome
      } : null,
      distribuidor_id: this.data.distribuidor?.id,
      email_proposta: this.data.email_proposta,
      cargas_prioritarias: this.formatarCargasPrioritarias(this.props.clonarProjeto),
      estruturas_calculadas: [],
      fileiras: this.fileiras.fileiras,
      fileiras_invalidas: this.fileiras.fileiras_invalidas,
      potencia_desejada_kw: this.data.solucao_sugerida.potencia_desejada_kw || 0,
      potencia_desejada_w: this.data.solucao_sugerida.potencia_desejada_w || 0,
      inversores: [],
      isEdit: true,
      modulo_selecionado: null,
      modulos: [],
      recebe_servico: this.mostrarOpcaoServico(),
      resultado_calculos: null,
      segmento: "distribuicao_ongrid",
      servico: this.data.servico,
      solucao_calculada: {
        baterias: [],
        inversores: [],
      },
      tensao_saida: this.data.solucao_sugerida && this.data.solucao_sugerida.tensao_saida ? (TENSAO_SAIDA_OPTIONS.find(item => item.id === this.data.solucao_sugerida.tensao_saida) || null) : null,
      old_componentes_edicao: [],
      old_estado_id: '',
      tipo_bateria: this.data.solucao_sugerida?.tipo_bateria ? (this.bateriasListagem.find(item => item.id === this.data.solucao_sugerida.tipo_bateria) || null) : HIBRIDO_SEM_BATERIA_OPTION,
      listagem_baterias_status: false,
      consumo_data_inicial: this.data.solucao_sugerida.consumo_data_inicial ? new Date(this.data.solucao_sugerida.consumo_data_inicial) : subMonths(new Date(), 11),
      consumo_data_final: this.data.solucao_sugerida.consumo_data_final ? new Date(this.data.solucao_sugerida.consumo_data_final) : subMonths(new Date(), 1),
      consumo_meses: this.data.solucao_sugerida.consumo_meses,
      estruturas_ativas: this.estruturasListagem.ativos,
      estruturas_paisagem: this.estruturasListagem.paisagem,
      estruturas_retrato: this.estruturasListagem.retrato,
      modo_potencia: this.data.solucao_sugerida.modo_potencia,
      taxa_descarga: this.data.solucao_sugerida.taxa_descarga ? (TAXA_DESCARGA_OPTIONS.find(opt => opt.id === this.data.solucao_sugerida.taxa_descarga) || null) : null,
      tipo_ligacao: this.data.solucao_sugerida.tipo_ligacao ? (TIPO_LIGACAO_OPTIONS.find(opt => opt.id === this.data.solucao_sugerida.tipo_ligacao) || null) : null,
      sugestoes: this.formatarSugestoes(),
    }
  }
}